import type { Plugin } from '@nuxt/types';

export default (({ $auth }) => {
  if (!process.env.isProduction) {
    // Show errors from auth for debugging
    $auth.onError((error, name) => {
      // eslint-disable-next-line no-console
      console.error('Auth error:', name, error);
    });
  }
}) as Plugin;
